
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire922e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire922e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $dea8c8e345018300$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["6Vzpu","index.8e2ee21e.js","gw87C","home_video_new.358ed4ac.webm","8LR7v","Main_Page_Phone.1098f144.webm"]'));

// const desktopUrl = "./src/assets/video/homevideo.mp4";
var $6fb4efee9bf3c6c0$exports = {};
$6fb4efee9bf3c6c0$exports = new URL("home_video_new.358ed4ac.webm", import.meta.url).toString();


const $41da4472f164f7c4$var$desktopUrl = new URL($6fb4efee9bf3c6c0$exports);
var $3b05213fe0f2e839$exports = {};
$3b05213fe0f2e839$exports = new URL("Main_Page_Phone.1098f144.webm", import.meta.url).toString();


const $41da4472f164f7c4$var$mobileUrl = new URL($3b05213fe0f2e839$exports);
window.addEventListener("DOMContentLoaded", ()=>{
    let video = document.querySelector("#hero-video");
    let source = document.createElement("source");
    source.type = "video/mp4";
    if (window.innerWidth > 900) source.src = $41da4472f164f7c4$var$desktopUrl;
    if (window.innerWidth < 900) source.src = $41da4472f164f7c4$var$mobileUrl;
    video.appendChild(source);
});


//# sourceMappingURL=index.8e2ee21e.js.map
